import _asyncToGenerator from "/home/runner/work/devtuple-website/devtuple-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/runner/work/devtuple-website/devtuple-website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/devtuple-website/devtuple-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/devtuple-website/devtuple-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/devtuple-website/devtuple-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/devtuple-website/devtuple-website/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*! markmap-common v0.13.4 | MIT License */
var Hook = /*#__PURE__*/function () {
  function Hook() {
    _classCallCheck(this, Hook);

    this.listeners = [];
  }

  _createClass(Hook, [{
    key: "tap",
    value: function tap(fn) {
      var _this = this;

      this.listeners.push(fn);
      return function () {
        return _this.revoke(fn);
      };
    }
  }, {
    key: "revoke",
    value: function revoke(fn) {
      var i = this.listeners.indexOf(fn);
      if (i >= 0) this.listeners.splice(i, 1);
    }
  }, {
    key: "revokeAll",
    value: function revokeAll() {
      this.listeners.splice(0);
    }
  }, {
    key: "call",
    value: function call() {
      var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var fn = _step.value;
          fn.apply(void 0, arguments);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return Hook;
}();

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["textContent"];

function escapeHtml(html) {
  return html.replace(/[&<"]/g, function (m) {
    return {
      '&': '&amp;',
      '<': '&lt;',
      '"': '&quot;'
    }[m];
  });
}

function escapeScript(content) {
  return content.replace(/<(\/script>)/g, '\\x3c$2');
}

function htmlOpen(tagName, attrs) {
  var attrStr = attrs ? Object.entries(attrs).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value == null || value === false) return;
    key = " ".concat(escapeHtml(key));
    if (value === true) return key;
    return "".concat(key, "=\"").concat(escapeHtml(value), "\"");
  }).filter(Boolean).join('') : '';
  return "<".concat(tagName).concat(attrStr, ">");
}

function htmlClose(tagName) {
  return "</".concat(tagName, ">");
}

function wrapHtml(tagName, content, attrs) {
  if (content == null) return htmlOpen(tagName, attrs);
  return htmlOpen(tagName, attrs) + (content || '') + htmlClose(tagName);
}

function buildCode(fn, args) {
  var params = args.map(function (arg) {
    if (typeof arg === 'function') return arg.toString();
    return JSON.stringify(arg != null ? arg : null);
  }).join(',');
  return "(".concat(fn.toString(), ")(").concat(params, ")");
}

function persistJS(items, context) {
  return items.map(function (item) {
    if (item.type === 'script') {
      var _item$data = item.data,
          textContent = _item$data.textContent,
          rest = _objectWithoutPropertiesLoose(_item$data, _excluded);

      return wrapHtml('script', textContent || '', rest);
    }

    if (item.type === 'iife') {
      var _item$data3 = item.data,
          fn = _item$data3.fn,
          getParams = _item$data3.getParams;
      return wrapHtml('script', escapeScript(buildCode(fn, (getParams == null ? void 0 : getParams(context)) || [])));
    }

    return '';
  });
}

function persistCSS(items) {
  return items.map(function (item) {
    if (item.type === 'stylesheet') {
      return wrapHtml('link', null, _extends({
        rel: 'stylesheet'
      }, item.data));
    }
    /* else if (item.type === 'style') */


    return wrapHtml('style', item.data);
  });
}

var uniqId = Math.random().toString(36).slice(2, 8);
var globalIndex = 0;

function getId() {
  globalIndex += 1;
  return "mm-".concat(uniqId, "-").concat(globalIndex);
}

function noop() {// noop
}

function walkTree(tree, callback) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';

  var walk = function walk(item, parent) {
    return callback(item, function () {
      var _item$key;

      (_item$key = item[key]) == null ? void 0 : _item$key.forEach(function (child) {
        walk(child, item);
      });
    }, parent);
  };

  walk(tree);
}

function arrayFrom(arrayLike) {
  if (Array.from) return Array.from(arrayLike);
  var array = [];

  for (var i = 0; i < arrayLike.length; i += 1) {
    array.push(arrayLike[i]);
  }

  return array;
}

function flatMap(arrayLike, callback) {
  if (arrayLike.flatMap) return arrayLike.flatMap(callback);
  var array = [];

  for (var i = 0; i < arrayLike.length; i += 1) {
    var result = callback(arrayLike[i], i, arrayLike);
    if (Array.isArray(result)) array.push.apply(array, _toConsumableArray(result));else array.push(result);
  }

  return array;
}

function addClass(className) {
  var classList = (className || '').split(' ').filter(Boolean);

  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  rest.forEach(function (item) {
    if (item && classList.indexOf(item) < 0) classList.push(item);
  });
  return classList.join(' ');
}

function childSelector(filter) {
  if (typeof filter === 'string') {
    var tagName = filter;

    filter = function filter(el) {
      return el.tagName === tagName;
    };
  }

  var filterFn = filter;
  return function selector() {
    var nodes = arrayFrom(this.childNodes);
    if (filterFn) nodes = nodes.filter(function (node) {
      return filterFn(node);
    });
    return nodes;
  };
}

function wrapFunction(fn, _ref3) {
  var before = _ref3.before,
      after = _ref3.after;
  return function wrapped() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var ctx = {
      args: args,
      thisObj: this
    };

    try {
      if (before) before(ctx);
    } catch (_unused) {// ignore
    }

    ctx.result = fn.apply(ctx.thisObj, ctx.args);

    try {
      if (after) after(ctx);
    } catch (_unused2) {// ignore
    }

    return ctx.result;
  };
}

function defer() {
  var obj = {};
  obj.promise = new Promise(function (resolve, reject) {
    obj.resolve = resolve;
    obj.reject = reject;
  });
  return obj;
}

function memoize(fn) {
  var cache = {};
  return function memoized() {
    var key = "".concat(arguments.length <= 0 ? undefined : arguments[0]);
    var data = cache[key];

    if (!data) {
      data = {
        value: fn.apply(void 0, arguments)
      };
      cache[key] = data;
    }

    return data.value;
  };
}

function createElement(tagName, props, attrs) {
  var el = document.createElement(tagName);

  if (props) {
    Object.entries(props).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          value = _ref5[1];

      el[key] = value;
    });
  }

  if (attrs) {
    Object.entries(attrs).forEach(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          key = _ref7[0],
          value = _ref7[1];

      el.setAttribute(key, value);
    });
  }

  return el;
}

var memoizedPreloadJS = memoize(function (url) {
  document.head.append(createElement('link', {
    rel: 'preload',
    as: 'script',
    href: url
  }));
});

function loadJSItem(item, context) {
  if (item.type === 'script') {
    return new Promise(function (resolve, reject) {
      var _item$data;

      document.head.append(createElement('script', _extends({}, item.data, {
        onload: resolve,
        onerror: reject
      }))); // Run inline script synchronously

      if (!((_item$data = item.data) != null && _item$data.src)) resolve();
    });
  }

  if (item.type === 'iife') {
    var _item$data4 = item.data,
        fn = _item$data4.fn,
        getParams = _item$data4.getParams;
    fn.apply(void 0, _toConsumableArray((getParams == null ? void 0 : getParams(context)) || []));
  }
}

function loadCSSItem(item) {
  if (item.type === 'style') {
    document.head.append(createElement('style', {
      textContent: item.data
    }));
  } else if (item.type === 'stylesheet') {
    document.head.append(createElement('link', _extends({
      rel: 'stylesheet'
    }, item.data)));
  }
}

function loadJS(_x, _x2) {
  return _loadJS.apply(this, arguments);
}

function _loadJS() {
  _loadJS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(items, context) {
    var needPreload, _iterator3, _step3, item;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            needPreload = items.filter(function (item) {
              var _item$data2;

              return item.type === 'script' && ((_item$data2 = item.data) == null ? void 0 : _item$data2.src);
            });
            if (needPreload.length > 1) needPreload.forEach(function (item) {
              return memoizedPreloadJS(item.data.src);
            });
            context = _extends({
              getMarkmap: function getMarkmap() {
                return window.markmap;
              }
            }, context);
            _iterator3 = _createForOfIteratorHelper(items);
            _context.prev = 4;

            _iterator3.s();

          case 6:
            if ((_step3 = _iterator3.n()).done) {
              _context.next = 12;
              break;
            }

            item = _step3.value;
            _context.next = 10;
            return loadJSItem(item, context);

          case 10:
            _context.next = 6;
            break;

          case 12:
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](4);

            _iterator3.e(_context.t0);

          case 17:
            _context.prev = 17;

            _iterator3.f();

            return _context.finish(17);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 14, 17, 20]]);
  }));
  return _loadJS.apply(this, arguments);
}

function loadCSS(items) {
  var _iterator2 = _createForOfIteratorHelper(items),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      loadCSSItem(item);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

export { Hook, addClass, arrayFrom, buildCode, childSelector, defer, escapeHtml, escapeScript, flatMap, getId, htmlClose, htmlOpen, loadCSS, loadJS, memoize, noop, persistCSS, persistJS, walkTree, wrapFunction, wrapHtml };